// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#244880","paragraphColor":"#232323"};